module.exports = __webpack_public_path__ + "img/Meta-Conecta-2.ba637112.png";